import type { Doc } from "building-types/doc";
import type { PlanSetTemplateIdentifier } from "building-types/views/planSets";
import { builtInPlanSetTemplateIdLabels } from "building-types/views/planSets";
import { isBuiltInPlanSetTemplateIdentifier } from "building-types/views/planSetTemplateIdentifierTools";
import objectFind from "common/utils/objectFind";

interface DefaultPlanSetExportFileNameParams {
  doc?: Doc;
  planSetTemplateIdentifier: PlanSetTemplateIdentifier;
  exportContextName?: string;
}

export default function computeDefaultPlanSetExportFileName({
  doc,
  planSetTemplateIdentifier,
  exportContextName,
}: DefaultPlanSetExportFileNameParams): string {
  const [defaultPlanSetTemplateId] = Object.keys(builtInPlanSetTemplateIdLabels);
  const builtInTemplateName = builtInPlanSetTemplateIdLabels[defaultPlanSetTemplateId];
  const templateName = isBuiltInPlanSetTemplateIdentifier(planSetTemplateIdentifier)
    ? builtInTemplateName
    : doc?.planSetTemplates[planSetTemplateIdentifier.templateId]?.name;
  const instanceName = isBuiltInPlanSetTemplateIdentifier(planSetTemplateIdentifier)
    ? undefined
    : doc?.planSetTemplateConfigs[planSetTemplateIdentifier.templateConfigId ?? ""]?.name ||
      objectFind(
        doc?.planSetTemplateConfigs ?? {},
        (config) => config.parentId === planSetTemplateIdentifier.templateId,
      )?.name;

  const parts = [exportContextName?.trim(), templateName, instanceName].filter(Boolean);
  return parts.length > 0 ? parts.join(" - ") : "Plan Set";
}
